import req from './req';

export function apiGetObsAKsK () {
	return req.request({
		url: 'https://open.ultrasdk.com/ultra/api/v1/config/obs',
		method: 'get',
		params: {},
		errNotice: true
	});
}

